import React, { FunctionComponent } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { State } from '../../dataStore/reducers/reducerType'
import { mediaType as MediaType } from '@bt-react/constants'
import { ParticipantInformationInterface } from '../../dataStore/reducers/docs/syncUi/types'
import SpotlightDrawer from './SpotlightDrawer'
import { setMediaType } from '../../dataStore/actions/room/room'
import { closeSpotlightMediaDrawer } from '../../dataStore/actions/ui/uiActions'
import { setFocus, clearFocus, setAutoSpotlight, setLayout } from '../../dataStore/actions/room/room'
import selectPresenterDetailsFromSeatingOrder from '../../dataStore/selectors/selectPresenterDetailsFromSeatingOrder'
import constants from '@bt-react/constants'
import { LayoutsSlice } from '../../dataStore/slices/layouts'
import { LayoutType } from '../../dataStore/slices/layouts/layoutsSlice'
import getPresentersFromSeatingOrder from '../../dataStore/selectors/getPresentersFromSeatingOrder'

const dispatchSpotlightActions = (autoSpotlight: boolean, focusID: string | null, mediaType: MediaType, dispatchFunction) => {

  dispatchFunction(setAutoSpotlight(autoSpotlight))
  dispatchFunction(closeSpotlightMediaDrawer())

  if (focusID !== null) dispatchFunction(setFocus(focusID))
  else dispatchFunction(clearFocus())

  dispatchFunction(setMediaType(mediaType))

}

const dispatchLayoutAction = (currentLayouts: LayoutsSlice, layoutType: LayoutType, presenterLayoutsActive: boolean, dispatchFunction) => {
  dispatchFunction(setLayout({
    ...currentLayouts,
    presenterLayout: {
      ...currentLayouts.presenterLayout,
      presenterLayoutsActive,
      layoutType
    }
  }))
}

const SpotlightDrawerIndex: FunctionComponent = () => {
  const presenterDetails = useSelector((state: State) => getPresentersFromSeatingOrder(state))
  const focusedOnPresenterId = useSelector((state: State) => state.syncUi.focusOn) as string | null
  const drawerHidden = useSelector((state: State) => state.ui.selectedDrawer !== constants.drawerType.SPOTLIGHT) as boolean
  const dominantSpeaker = useSelector((state: State) => state.syncUi.dominantSpeaker) as string | null
  const autoSpotlight = useSelector((state: State) => state.syncUi.autoSpotlight) as boolean
  const mediaType = useSelector((state: State) => state.syncUi.mediaType) as MediaType
  const currentLayouts = useSelector((state: State) => state.layouts) as LayoutsSlice

  const dispatch = useDispatch()

  const onClick = () => dispatch(closeSpotlightMediaDrawer())

  const onAutoSpotlightClick = () => {

    dispatchSpotlightActions(true, dominantSpeaker, MediaType.SPOTLIGHT, dispatch)
    dispatchLayoutAction(currentLayouts, currentLayouts.presenterLayout.layoutType, true, dispatch)

  }

  const onPresenterClick = (id: string) => {

    dispatchSpotlightActions(false, id, MediaType.SPOTLIGHT, dispatch)
    dispatchLayoutAction(currentLayouts, currentLayouts.presenterLayout.layoutType, true, dispatch)

  }

  const onAllPresentersClick = () => {

    dispatchSpotlightActions(false, null, MediaType.WEBCAM, dispatch)
    dispatchLayoutAction(currentLayouts, currentLayouts.presenterLayout.layoutType, false, dispatch)

  }


  return <SpotlightDrawer
    onClick={onClick}
    hidden={drawerHidden}
    presenterDetails={presenterDetails}
    onPresenterClick={onPresenterClick}
    focusedOnPresenterId={focusedOnPresenterId}
    onAutoSpotlightClick={onAutoSpotlightClick}
    autoSpotlight={autoSpotlight}
    onAllPresentersClick={onAllPresentersClick}
    mediaType={mediaType}
  />
}

export default SpotlightDrawerIndex